import { Link } from "react-router-dom";
// import banner1 from "../../../assets/images/media/banner1.png";
// import banner1_1 from "../../../assets/images/media/banner1.1.png";
// import banner1_2 from "../../../assets/images/media/banner1.2.png";
// import banner1_3 from "../../../assets/images/media/banner1.3.png";
// import banner1_4 from "../../../assets/images/media/banner1.4.png";
// import banner1_5 from "../../../assets/images/media/banner1.5.png";
import { LazyLoadImage } from "react-lazy-load-image-component";

function BannerOne() {
 return (
  <div
   className="hero-banner-promo-one"
   style={{ transition: "opacity 1s ease-in-out" }}
  >
   <div className="body">
    <div className="section-text">
     <h2>Tu Tienda Virtual para vender de todo</h2>
     <div className="content-text">
      <p className="first-p">
       ¡Despreocúpate! PowerBizz te da el hosting como parte del servicio.{" "}
      </p>
      <div className="content-button">
       {/* <input
                placeholder="Correo electrónico"
              // value={}
              /> */}
       <Link to={"/nueva-tienda"} className="btn-one">
        Crear tu tienda
       </Link>
      </div>
      <p>
       ¡No cobramos comisiones! Empieza a vivir la experiencia de una Tienda
       Online.
      </p>
     </div>
    </div>
    <div className="section-banner">
     <div className="first-column">
      <LazyLoadImage
       className="image-one"
       src={"https://a-s3-backoffice.s3.amazonaws.com/web/banner1_udn6ay.png"}
      />
      <LazyLoadImage
       className="image-two"
       src={"https://a-s3-backoffice.s3.amazonaws.com/web/banner1.1_sshcj5.png"}
      />
      <LazyLoadImage
       className="image-three"
       src={"https://a-s3-backoffice.s3.amazonaws.com/web/banner1.2_nwy2bd.png"}
      />
     </div>
     <div className="second-column">
      <LazyLoadImage
       className="image-four"
       src={"https://a-s3-backoffice.s3.amazonaws.com/web/banner1.3_x8xwec.png"}
      />
      <LazyLoadImage
       className="image-five"
       src={"https://a-s3-backoffice.s3.amazonaws.com/web/banner1.4_xl23zz.png"}
      />
      <LazyLoadImage
       className="image-six"
       src={"https://a-s3-backoffice.s3.amazonaws.com/web/banner1.5_yvezeo.png"}
      />
     </div>
    </div>
   </div>
  </div>
 );
}

export default BannerOne;
